module.exports = "button{\r\n  color:white;\r\n}\r\n.mat-menu-item{\r\n  color:black;\r\n}\r\n.right-side {\r\n  padding: 0 14px;\r\n}\r\n.menu-spacer {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/nav-menu/nav-menu.component.css
// module id = ./src/app/nav-menu/nav-menu.component.css
// module chunks = main